import {
  GET_NOTES_FLOTILLA,
  RESET_FLOTILLA_STORE,
  SET_FLOTILLA_INPUTS,
} from "redux/reducers/notesFlotilla/notesFlotillaReducer";
import {
  setSnackbar,
  startRequest,
  stopRequest,
} from "redux/actions/search/searchActions";
import { api_get, PROYECT } from "services/api"
import { extractIDs } from "helpers/extractIDs";

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`

export const getNotesFlotilla = (stations, startDate, endDate) => {
  const ids = extractIDs(stations)
  const params = ids.map(id => `idStation=${id}`).join("&")
  const url = `${mainUrl}/notes/taxis?start=${startDate}&end=${endDate}&${params}`
  return async (dispatch) => {
    dispatch(startRequest())
    await api_get(url).then(resp => {
      dispatch({
        type: GET_NOTES_FLOTILLA,
        payload: resp
      })
    }).catch(err => {
      const message = err ? err : 'Error en la solicitud'
      dispatch(setSnackbar(message))
    })
    dispatch(stopRequest())
  }
}

export const flotillaSearchInputs = (key = '', value) => {
  return {
    type: SET_FLOTILLA_INPUTS,
    payload: { key, value }
  }
}

export const restoreFlotillasStore = () => {
  return {
    type: RESET_FLOTILLA_STORE
  }
}
